import { createBrowserHistory } from 'history';

export const navigate = (url, refresh = false) => {
  if (!url) return;

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    // clean up the url before navigation
    let _url = '';
    const urlObj = new URL(`${window.location.origin}${url}`);
    const { pathname, searchParams } = urlObj;
    const search = searchParams.toString();
    _url = `${window.location.origin}${pathname}?${search}`;
    // Navigate to new URL
    const history = createBrowserHistory();
    history.push(_url);
    if (refresh) {
      history.go();
    }
  }
};

export const fetchJson = async (_path) => {
  try {
    const fetchJsonResponse = await fetch(_path);
    const gcMallJsonResponse = await fetchJsonResponse.json(fetchJsonResponse);
    return gcMallJsonResponse;
  } catch (error) {
    console.error(error); // eslint-disable-line
    return error;
  }
};

export const isLocalHost = () => {
  if (typeof window !== 'undefined') {
    const loc = window.location.pathname;
    const host = !!loc.match(/chapters/g);
    return host;
  }
  return false;
};

export const getEnv = () => {
  let env = '';
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    if (origin.match(/local/g)) {
      env = 'local';
    } else if (origin.match(/homedepotdev/g)) {
      env = 'llc';
    } else {
      env = 'prod';
    }
  }
  return env;
};

export const getJsonPath = () => {
  let firstPartyJsonUrl = '';
  let thirdPartyJsonUrl = '';
  let currentEnv = getEnv();
  if (currentEnv === 'local' || currentEnv === 'llc') {
    firstPartyJsonUrl = 'https://assets-qa.thdstatic.com/giftcards-qa/catalog/listings/homedepot.json';
    thirdPartyJsonUrl = 'https://assets-qa.thdstatic.com/giftcards-qa/catalog/listings/thirdparty.json';
  } else if (currentEnv === 'prod') {
    firstPartyJsonUrl = 'https://assets.thdstatic.com/giftcards/catalog/listings/homedepot.json';
    thirdPartyJsonUrl = 'https://assets.thdstatic.com/giftcards/catalog/listings/thirdparty.json';
  }
  return { firstPartyJsonUrl, thirdPartyJsonUrl };
};
